import { StatusTranslationKey } from '@/types/status';
import { ContentState } from '../contentState/ContentState';

export const PendingEventsTable = () => <ContentState status={StatusTranslationKey.LOADING} />;
